import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAppCheck } from './appCheck';

// Initialize Firebase App Check with reCAPTCHA v3
try {
  initAppCheck();
} catch (err) {
  console.warn('[App Check] Init failed:', err.message);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
